import { USER_TARGETING_COOKIE_NAME, USER_TARGETING_ORIGIN_HASH_COOKIE_NAME } from '../constants';
import { CookieUtils } from '../types/cookies_utils';
import Identifier from './identifiers';

class UserTargeting {
  constructor(
    private readonly identifier: Identifier,
    private readonly cookieUtils: CookieUtils,
  ) {}

  getUserTargetingId() {
    // This does nothing if valid Targeting cookie has been set already
    this.identifier.authorizeIdentifier(USER_TARGETING_COOKIE_NAME);

    return this.cookieUtils.getCookie(USER_TARGETING_COOKIE_NAME);
  }

  getUserTargetingIdOriginHash() {
    const cookie = this.cookieUtils.getCookie(USER_TARGETING_ORIGIN_HASH_COOKIE_NAME);

    return cookie && decodeURIComponent(cookie);
  }

  checkResetUserTargetingId(userId: string) {
    return this.identifier.checkResetIdentifier(
      userId,
      USER_TARGETING_ORIGIN_HASH_COOKIE_NAME,
      USER_TARGETING_COOKIE_NAME,
    );
  }
}

export default UserTargeting;
